import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B192C] text-[#CBD5E1]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 sm:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div>
            <img src="/logo-full.jpg" alt="Kobi-Line - Sertifikalı Danışmanlık Kalitesi" className="h-16 rounded-xl" data-testid="footer-logo" />
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#94A3B8]">
              KOBİ'ler için dijital dönüşüm ve ücretsiz ön analiz portalı.
              Firmanızın dijital potansiyelini birlikte ortaya çıkaralım.
            </p>
          </div>
          <a
            href="#form"
            data-testid="footer-cta-link"
            className="group inline-flex items-center gap-2 font-display text-xl sm:text-2xl font-bold text-white hover:text-[#93C5FD] transition-colors"
          >
            Ücretsiz Analize Başvurun
            <ArrowUpRight size={22} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
        <div className="mt-12 pt-8 border-t border-[#1E293B] flex flex-col gap-5">
          <div className="flex flex-col sm:flex-row flex-wrap items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[#94A3B8]" data-testid="footer-contact">
              <a href="tel:+902129120262" data-testid="footer-phone-1" className="hover:text-white transition-colors">0212-9120262</a>
              <a href="tel:+908508112444" data-testid="footer-phone-2" className="hover:text-white transition-colors">0850 811 2 444</a>
              <a href="https://wa.me/902129094235" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-white transition-colors">WhatsApp: 0212 909 42 35</a>
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-[#64748B]">
              <a href="https://www.kobi-line.com.tr/gizlilik-politikasi" target="_blank" rel="noopener noreferrer" data-testid="footer-kvkk-link" className="hover:text-white transition-colors">KVKK Gizlilik Politikası</a>
              <a href="https://www.kobi-line.com.tr/uyelik-sozlesmesi" target="_blank" rel="noopener noreferrer" data-testid="footer-membership-link" className="hover:text-white transition-colors">Üyelik Sözleşmesi</a>
              <a href="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Yönetim Paneli</a>
            </div>
          </div>
          <p className="text-xs text-[#64748B]">© {new Date().getFullYear()} Kobi-Line. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
